import { render, staticRenderFns } from "./markup-editor.vue?vue&type=template&id=789d57fa&"
import script from "./markup-editor.vue?vue&type=script&lang=js&"
export * from "./markup-editor.vue?vue&type=script&lang=js&"
import style0 from "./markup-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "markup-editor.vue"
export default component.exports